package com.vizio.redwolf.auth.model

import com.vizio.redwolf.utils.SUBSCRIPTION_API_KEY
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpMethod

val secureHeaders = listOf(SUBSCRIPTION_API_KEY, HttpHeaders.Authorization)
val secureEndpoints = listOf(
    Endpoint("/myvizio-api/v2/users", HttpMethod.Post),
    Endpoint("/myvizio-api/v2/users/authorizations", HttpMethod.Post),
    Endpoint("/myvizio-api/v2/users/full-account", HttpMethod.Post),
    Endpoint("/myvizio-api/users", HttpMethod.Post),
    Endpoint("/myvizio-api/users/authorizations", HttpMethod.Post),
    Endpoint("/myvizio-api/users/full-account", HttpMethod.Post)
)
